import { CSSObject } from '@emotion/react'
import { fonts, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const contentStyle: CSSObject = {
  fontSize: '30px',
  color: 'white',
  fontFamily: fonts.proximaBlack,
  fontWeight: fontWeights.boldest,
  textAlign: 'center',
  zIndex: 1000,
  padding: '0 15px',
}

const contentWrapperStyle: CSSObject = {
  width: '375px',
  overflow: 'auto',
  maxHeight: '144px',
  position: 'absolute',
  bottom: '81px',

  '.kuiper-input.kuiper-filled .kuiper-input-container, .kuiper-input.kuiper-focused .kuiper-input-container, .kuiper-input-container':
    {
      backgroundColor: 'unset',
      color: 'white',
    },
  '.kuiper-input-element::placeholder': {
    color: 'white !important',
  },
  '.kuiper-input-element:focus::placeholder': {
    color: 'rgba(0,0,0,0) !important',
  },
}

const assetWrapper: CSSObject = {
  position: 'relative',
  width: '375px',
  height: '667px',
  backgroundColor: 'gray',
}

const assetStyle: CSSObject = {
  display: 'flex',
  overflow: 'hidden',
  minWidth: '100px',
  width: '375px',
  height: '667px',
  backgroundColor: colors.n8.base,
  'img, video': {
    width: '375px',
  },
}

const getAssetBaseStyle = (assetType: string): CSSObject => ({
  display: 'flex',
  overflow: 'hidden',
  minWidth: '100px',
  width: '375px',
  backgroundColor: colors.n8.base,
  'img, video': {
    width: '375px',
  },
  height: assetType === 'video' ? '667px' : 'unset',
})

const overlayStyles: CSSObject = {
  position: 'absolute',
  height: '667px',
  width: '375px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}

const styles = {
  assetStyle,
  assetWrapper,
  contentStyle,
  contentWrapperStyle,
  getAssetBaseStyle,
  overlayStyles,
}

export { styles }
